export default {
  callingAPI: false,
  searching: '',
  serverURI: '',
  user: null,
  token: null,
  networkError: false,
  tempToken: null
}
